import { Button, Col, Container, Row } from "react-bootstrap";
import Formulario from "../Formulario/Formulario";

const Registrate = () => {
  return (
    <Container fluid className="preventaDiv pt-4 mb-5 pb-5">
      <Container>
        <Row>
          <Col className="text-center pt-3 pb-3 d-flex justify-content-center flex-column mt-3 mb-3">
            <h1 className="me-3 pt-1 pb-4">DESCUBRILA PRIMERO EN MONTIRONI</h1>
            {/* <h3>Completá tus datos y obtené mas información</h3> */}
            <h3>Completá tus datos y reservá tu visita</h3>
          </Col>
        </Row>
        <Row>
          <Col md={11} className="mx-auto">
            <Formulario />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Registrate;
